var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('label',{staticClass:"button-gemnote button-gemnote--small",class:{
      'whitebutton-gemnote whitebutton-gemnote--small text-sm text-bold': _vm.isWhiteVariant
    },style:(_vm.customStyles),attrs:{"for":"upload-file"}},[_c('input',{attrs:{"type":"file","id":"upload-file","hidden":"","accept":".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"},on:{"change":_vm.handleFile}}),_c('span',[_vm._v(_vm._s(_vm.text))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }